import Divider from 'LuxKit/Divider'
import LineCoinsIcon from 'LuxKit/Icons/line/LineCoinsIcon'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

function SocieteRewardsBenefits() {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={16}>
      <Group direction="vertical" gap={8}>
        <Heading variant="heading4">
          {intl.formatMessage({
            id: '2KonW4-k9H54Tbj8MO6g',
            defaultMessage: 'Earn rewards every time you book',
            description: 'Heading for the Société rewards benefits section in the linking modal',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: '5GdSu6dwOyaNintIqSXo',
            defaultMessage: 'Link your Société account and start turning every dollar you book into points, perks and extra commission.',
            description: 'Subtitle for the Société rewards benefits section in the linking modal',
          })}
        </BodyText>
      </Group>

      <Group direction="horizontal" gap={16} horizontalAlign="start">
        <LineCoinsIcon colour="neutral-two" size="M" />
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'GThXfHw4CG4VJas4GmVr',
              defaultMessage: 'Points on every dollar you spend',
              description: 'Benefit card title for earning Societe points on every booking',
            })}
          </BodyText>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'KET7TlqBNOU55vNrkEMc',
              defaultMessage: 'Every booking you make earns Société points automatically — no opt-ins, no minimum spend.',
              description: 'Benefit card description for automatic Societe points earning',
            })}
          </BodyText>
        </Group>
      </Group>

      <Group direction="horizontal" gap={16} horizontalAlign="start">
        <LineStarIcon colour="neutral-two" size="M" />
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'rEqZD_Yk0tWDxYZ5KK1j',
              defaultMessage: 'Bonus points for hitting goals',
              description: 'Benefit card title for earning bonus Societe points through challenges',
            })}
          </BodyText>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'kZ6cdlRUbUwI__w9umrI',
              defaultMessage: 'Complete challenges and join campaigns to stack bonus points on top of your everyday earnings.',
              description: 'Benefit card description for bonus points through challenges and campaigns',
            })}
          </BodyText>
        </Group>
      </Group>

      <Group direction="horizontal" gap={16} horizontalAlign="start">
        <LineGiftIcon colour="neutral-two" size="M" />
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'RACaTiglYFyYmcUEU5Lf',
              defaultMessage: 'Redeem your way',
              description: 'Benefit card title for flexible Societe points redemption options',
            })}
          </BodyText>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'FyvnzNPIunxwxq3dik75',
              defaultMessage: 'Use points to discount client trips, shop in LE Shop, or cash out as bonus commission — your choice.',
              description: 'Benefit card description for flexible redemption options',
            })}
          </BodyText>
        </Group>
      </Group>
      <Divider kind="primary" />
    </Group>
  )
}

export default SocieteRewardsBenefits
